import { render, staticRenderFns } from "./ComandoVelocidadAsignacion.vue?vue&type=template&id=f0e63138&scoped=true&"
import script from "./ComandoVelocidadAsignacion.vue?vue&type=script&lang=ts&"
export * from "./ComandoVelocidadAsignacion.vue?vue&type=script&lang=ts&"
import style0 from "./ComandoVelocidadAsignacion.vue?vue&type=style&index=0&id=f0e63138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e63138",
  null
  
)

export default component.exports